import ApiService from "@/core/services/api.service";
const _ = require('lodash');

export const GET_CRITERIA_STANDARD = "teamlead/criteria-standard";
export const GET_TEAMLEAD_REVIEW = "teamlead/review";
export const SCORE_CONVERTION = "teamlead/score-conversion";
export const UPDATE_TEAMLEAD_REVIEW = "teamlead/update-review";

const state = {
    errors: null,
};

const getters = {};

const actions = {
    [GET_CRITERIA_STANDARD](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_CRITERIA_STANDARD, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_TEAMLEAD_REVIEW](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_TEAMLEAD_REVIEW, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [UPDATE_TEAMLEAD_REVIEW](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(UPDATE_TEAMLEAD_REVIEW + '/' + payload.id, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [SCORE_CONVERTION](context, payload) {
        let postData = {
            score_actual: payload.score_actual,
        };
        return new Promise((resolve, reject) => {
            ApiService.post(SCORE_CONVERTION + '/' + payload.id, postData).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
}

const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
